import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/modules/api-axios'
import AesUtil from '@/modules/aes-util'
import CryptoJS from 'crypto-js'

Vue.use(Vuex)

const AUTH_REQUEST = 'AUTH_REQUEST'
const AUTH_SUCCESS = 'AUTH_SUCCESS'
const AUTH_ERROR = 'AUTH_ERROR'
const AUTH_LOGOUT = 'AUTH_LOGOUT'
const AUTH_PW_INIT = 'AUTH_PW_INIT'
const AUTH_USER = ['user_seq', 'user_id', 'user_name', 'user_type', 'auth_grp', 'access_token', 'pw_init_yn', 'user_profile', 'active_mode']
const EXAM_TMP_REGISTER = 'EXAM_TMP_REGISTER'
const EXAM_TMP_DELETE = 'EXAM_TMP_DELETE'
const PAGE_PARAMS_REGISTER = 'PAGE_PARAMS_REGISTER'
const PAGE_PARAMS_DELETE = 'PAGE_PARAMS_DELETE'
const USER_INFO_UPDATE = 'USER_INFO_UPDATE'

function crypto (user) {
  const key = 'oliver'
  user.id = encrypt(key, user.id)
  user.pw = encrypt(key, user.pw)
  delete user.key
  return user
}

function encrypt (key, value) {
  const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex)
  const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex)
  const aesUtil = new AesUtil(128, 1000)
  const ciphertext = aesUtil.encrypt(salt, iv, key, value)
  const aesCiphertext = iv + '::' + salt + '::' + ciphertext
  return btoa(aesCiphertext)
}

export default new Vuex.Store({
  state: {
    status: '',
    user_seq: localStorage.getItem('user_seq') || '',
    user_id: localStorage.getItem('user_id') || '',
    user_name: localStorage.getItem('user_name') || '',
    user_type: localStorage.getItem('user_type') || '',
    user_profile: localStorage.getItem('user_profile') || '',
    auth_grp: localStorage.getItem('auth_grp') || '',
    access_token: localStorage.getItem('access_token') || '',
    pw_init_yn: localStorage.getItem('pw_init_yn') || '',
    active_mode: localStorage.getItem('active_mode') || '',
    tmp_exam: JSON.parse(localStorage.getItem('tmp_exam')) || {},
    page_params: JSON.parse(localStorage.getItem('page_params')) || {}
  },
  getters: {
    isAuthenticated: state => !!state.access_token,
    authStatus: state => state.status,
    user_seq: state => state.user_seq,
    user_id: state => state.user_id,
    user_name: state => state.user_name,
    user_type: state => state.user_type,
    user_profile: state => state.user_profile,
    auth_grp: state => state.auth_grp,
    access_token: state => state.access_token,
    active_mode: state => state.active_mode,
    isPasswordInit: state => state.pw_init_yn === 'Y',
    tmp_exam: state => state.tmp_exam,
    page_params: state => state.page_params
  },
  mutations: {
    [AUTH_REQUEST]: (state) => {
      state.status = 'loading'
    },
    [AUTH_SUCCESS]: (state, result) => {
      state.status = 'success'
      AUTH_USER.map(key => {
        localStorage.setItem(key, result[key] ? result[key] : '')
        state[key] = result[key] ? result[key] : ''
      })
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + result.access_token
    },
    [AUTH_ERROR]: (state) => {
      state.status = 'error'
    },
    [AUTH_LOGOUT]: (state) => {
      state.status = 'logout'
      AUTH_USER.map(key => {
        localStorage.removeItem(key)
        state[key] = ''
      })
      delete axios.defaults.headers.common['Authorization']
    },
    [AUTH_PW_INIT]: (state) => {
      localStorage.setItem('pw_init_yn', 'N')
      state.pw_init_yn = 'N'
    },
    [EXAM_TMP_REGISTER]: (state, result) => {
      const exam = Object.assign({}, state.tmp_exam)
      if (!exam[result.user_seq]) {
        exam[result.user_seq] = {}
      }
      if (!exam[result.user_seq][result.class_seq]) {
        exam[result.user_seq][result.class_seq] = {}
      }
      exam[result.user_seq][result.class_seq][result.exam_seq] = result.exam_answer
      localStorage.setItem('tmp_exam', JSON.stringify(exam))
      state.tmp_exam = exam
    },
    [EXAM_TMP_DELETE]: (state, result) => {
      const exam = Object.assign({}, state.tmp_exam)
      if (exam[result.user_seq] && exam[result.user_seq][result.class_seq] && exam[result.user_seq][result.class_seq][result.exam_seq]) {
        delete exam[result.user_seq][result.class_seq][result.exam_seq]
        if (Object.keys(exam[result.user_seq][result.class_seq]).length === 0) {
          delete exam[result.user_seq][result.class_seq]
          if (Object.keys(exam[result.user_seq]).length === 0) {
            delete exam[result.user_seq]
          }
        }
      }
      localStorage.setItem('tmp_exam', JSON.stringify(exam))
      state.tmp_exam = exam
    },
    [PAGE_PARAMS_REGISTER]: (state, params) => {
      localStorage.setItem('page_params', JSON.stringify(params))
      state.page_params = params
    },
    [PAGE_PARAMS_DELETE]: (state) => {
      localStorage.removeItem('page_params')
      state.page_params = {}
    },
    [USER_INFO_UPDATE]: (state, result) => {
      const userProfile = ['user_name', 'school_name', 'user_profile']
      userProfile.map(key => {
        localStorage.setItem(key, result[key] ? result[key] : '')
        state[key] = result[key] ? result[key] : ''
      })
    }
  },
  actions: {
    [AUTH_REQUEST]: ({commit, dispatch}, user) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_REQUEST)
        axios.post('/auth/login', crypto(user))
          .then(response => {
            if (response.data.status === 1) {
              commit(AUTH_SUCCESS, response.data)
            }
            resolve(response)
          })
          .catch(error => {
            commit(AUTH_ERROR, error)
            reject(error)
          })
      })
    },
    [AUTH_LOGOUT]: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_LOGOUT)
        resolve()
      })
    },
    [AUTH_PW_INIT]: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_PW_INIT)
        resolve()
      })
    },
    [EXAM_TMP_REGISTER]: ({commit, dispatch}, exam) => {
      return new Promise((resolve, reject) => {
        commit(EXAM_TMP_REGISTER, exam)
        resolve()
      })
    },
    [EXAM_TMP_DELETE]: ({commit, dispatch}, exam) => {
      return new Promise((resolve, reject) => {
        commit(EXAM_TMP_DELETE, exam)
        resolve()
      })
    },
    [PAGE_PARAMS_REGISTER]: ({commit, dispatch}, params) => {
      return new Promise((resolve, reject) => {
        commit(PAGE_PARAMS_REGISTER, params)
        resolve()
      })
    },
    [PAGE_PARAMS_DELETE]: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
        commit(PAGE_PARAMS_DELETE)
        resolve()
      })
    },
    [USER_INFO_UPDATE]: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
        axios.get('/user/profile/' + localStorage.getItem('user_seq'), {})
          .then(response => {
            commit(USER_INFO_UPDATE, response.data)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js